<template>
    <div class="container" v-cloak>
        <div class="center">
            <nav aria-label="breadcrumb" class="breadcrumb justify-content-center">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item" v-for="crumb in category.breadcrumbs"><a :href="crumb.url">{{ crumb.name }}</a></li>
                    <li class="breadcrumb-item"><a :href="category.url">{{ category.name }}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ product.name }}</li>
                </ol>
            </nav>
        </div>
        
        
        <h1 class="center">{{ product.name }}</h1>

        <div class="spacer mobile"></div>
        <!--Featured-->

        <div class="row">

            <div class="col-md">
                <carousel :per-page="1"
                          :mouse-drag="true"
                          :pagination-enabled="false"
                          :loop="true"
                          :navigation-enabled="true"
                          :autoplay="true"
                          :autoplay-hover-pause="true"
                          :autoplay-timeout="5000"
                >
                    <slide v-for="(image, i) in product.images['800x800']" :key="i">
                        <img v-if="product.is_black_friday" class="express-delivery-product doorbuster" src="/themes/rentone/assets/images/black-friday-badge.png">
                        <img v-else-if="product.is_holiday_deal" class="express-delivery-product doorbuster" src="/themes/rentone/assets/images/holiday-deals-sticker.png">
                        <img v-else-if="product.is_express_delivery" class="express-delivery-product" src="/themes/rentone/assets/images/express-delivery.svg">
                        <img :src="image"/>
                    </slide>
                </carousel>
            </div>
            <div class="col-md">
                <p class="manufacturer" v-if="brand">by {{ brand }}</p>
                <p class="model">Model #{{ product.model }}</p>

                 <span class="badge badge-pill badge-primary usp badge-sm">No Credit Check</span>
        <span class="badge badge-pill badge-primary usp badge-sm">Flexible Payment Options</span>
        <span class="badge badge-pill badge-primary usp badge-sm">Free Delivery</span>
        <span class="badge badge-pill badge-primary usp badge-sm">Free In-Store Pickup</span>


                <h5 class="mt-3">Choose Your Payment Options</h5>
                <product-pricing-tab
                    v-model="activePrice"
                    :active-price-id="activePrice.id"
                    :pricing-options="this.product.pricing.filter((p) => { return p.active })">
                </product-pricing-tab>
                <p class="RTOtotal" v-show="shouldShowTotalRTO">
                  <span v-bind:class="{ 'line-through': isOnSale }">RTO Total: ${{ totalRTOPrice['original'] }}</span>
                  <br>
                  <span v-if="this.activePrice.cost_of_lease_services">Cost of Lease Services: {{ this.activePrice.cost_of_lease_services }}</span>
                  <br>
                  <span v-if="isOnSale" class="">
                  <span class="newpricehighlight">New Price: {{ this.activePrice.sale_formatted }}</span>
                  <br>
                  New RTO Total: ${{ totalRTOPrice['price'] }}
                  <br>
                   <span class="newprice">SAVINGS: ${{ totalRTOPrice['savings'] }}</span>
                  <br>
                  </span>
                  <br>
                <a href="/disclosure" target="_blank">Purchase & Delivery Disclosure</a></p>
                <div v-for="linked in product.options.linked">
                    <linked-option :name="linked.name" :options="linked.data" :current-product-id="product.id"></linked-option>
                </div>

                <div class="error" v-if="showOptionError">You must select an option</div>
                <div v-for="multiple in product.options.multiple">
                    <multiple-option :name="multiple.name" :options="multiple.data" @select-multiple="saveMultipleOption"></multiple-option>
                </div>

                <ul class="list-group">
                    <li
                        class="list-group-item"
                        v-for="(option, name) in product.options.single"
                        v-if="!option.data[0].hide_from_product">
                        {{ name }}: {{option.data[0].value }}
                    </li>
                </ul>

                <div class="spacer"></div>




                <button type="button" class="btn btn-danger cart" @click="addToCart()">ADD TO CART</button>

            </div>
        </div>
        <div class="spacer"></div>
 <p class="description" v-html="product.description"></p>

        <div class="spacer"></div>

    </div>
</template>


<script>
    import LinkedOption from './LinkedOption.vue';
    import MultipleOption from './MultipleOption.vue';
    import ProductPricingTab from "../../../../../shared/components/ProductPricingTab";
    import {Carousel, Slide} from 'vue-carousel';

    import {ServiceFactory} from '../../../../../shared/assets/js/services/ServiceFactory';

    const CartService = ServiceFactory.get('cart');

    export default {
        components: {
            LinkedOption,
            MultipleOption,
            ProductPricingTab,
            Carousel,
            Slide
        },

        props: ['product', 'category'],

        data() {
            return {
                activePrice: null,
                options: {},
                showOptionError: false,
            }
        },

        created() {
            const comeFromCategoryPrice = this.tryGettingComeFromCategoryPrice();
            const categoryRentonePriceId = comeFromCategoryPrice || this.category.display_price_rentone;
            const productPrices = this.product.pricing;
            const pricing = productPrices.find(({id}) => id === categoryRentonePriceId) || productPrices[0];
            if (pricing != null) {
                this.activePrice = pricing;
                let amount = pricing.amount;
                if (pricing.sale_amount > 0 && pricing.sale_amount < amount) {
                    amount = pricing.sale_amount;
                }
            }
        },

        mounted() {
            const regex = new RegExp(/^.*\//);
            const baseUrl = regex.exec(window.location.href);
            const { product } = this;
            const ccProduct = {
                id: product.id,
                name: product.name,
                url: `${baseUrl}${product.url}`,
                image: product.images['800x800'][0],
                price: this.activePrice.amount,
                currency: 'USD',
                inStock: product.active,
            }
            
            window.ccLayer = window.ccLayer || [];
            ccLayer.push({
                ccEvent: 'productViewed',
                src: 'custom',
                ...ccProduct,            
            });
        },

        computed: {
            brand() {
                if (this.product.options.single.Brand !== undefined) {
                    return this.product.options.single.Brand.data[0].value;
                }

                return '';
            },

            shouldShowTotalRTO() {
              return this.activePrice ? this.activePrice.show_total_cost : false;
            },

            isOnSale () {
              return this.activePrice.has_sale;
            },

            totalRTOPrice() {
                return {
                    'label': this.activePrice.total_rto_cost_label,
                    'price': this.activePrice.total_rto_cost,
                    'original': this.activePrice.original_total_rto_cost,
                    'savings': (parseFloat(this.activePrice.original_total_rto_cost) -  parseFloat(this.activePrice.total_rto_cost)).toFixed(2),
                }
            }
        },

        methods: {

            async addToCart() {
                this.showOptionError = !this.validateOptions();

                if (!this.showOptionError) {
                    try {
                        CartService.add(this.product.slug, this.options, this.activePrice.id, 1)
                          .finally(() => {
                              console.log('Moving to new cart page...');
                              window.location.replace('/cart');
                          });
                    } catch (error) {
                        console.error('something went wrong');
                    }
                }
            },

            saveMultipleOption(name, option) {
                this.options[name] = option;
                this.showOptionError = false;
            },

            validateOptions() {
                const options = _(this.product.options.multiple);

                const needSelection = options
                    .keys()
                    .reject((name) => this.options[name] !== undefined)
                    .value();

                if (needSelection.length > 0) {
                    return false;
                }

                return true;
            },

            tryGettingComeFromCategoryPrice() {
              const params = window.location.href.split('?')[1];
              if (!params) {
                return;
              }

              const keysAndValues = params.split('&');
              for (let i = 0; i < keysAndValues.length; i++) {
                const keyAndValue = keysAndValues[i];
                const [key, value] = keyAndValue.split('=');
                if (key === 'categoryDisplayPrice') {
                  return parseInt(value);
                }
              }
            }
        },
    }
</script>
